module.exports = __webpack_public_path__ + "img/selected3-min.ce58ca0a.png";